var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('OButton',{staticClass:"absolute z-2 transform -translate-y-1/2 u-center text-white swiper-button-custom h-9 w-9 rounded-full",class:{
    'swiper-button-custom-prev left-4': _vm.direction === 'prev',
    'swiper-button-custom-next right-4': _vm.direction === 'next',
  },attrs:{"pure":""}},[_c('OIcon',{attrs:{"icon":_vm.direction === 'prev' ? 'left-white' : 'right-white',"svg-style":"fill: #fff"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }